<template>
  <div>
    <Breadcrumb :dataSource="breadcrumbList" />
    <div class="page-container" style="padding-top: 0">
      <a-tabs :default-active-key="tabKey" @change="handleTabChange">
        <a-tab-pane v-for="item in tabPaneConfig" :key="item.key" :tab="item.tab">
          <TableList
            :columns="columns"
            :tableData="dataSource"
            :loading="loading"
            :scroll="{}"
            :pagination="ipagination"
            @change="handleTableChange"
            style="min-height: 350px"
          >
            <div slot="queryArea" class="query-area">
              <div>
                <j-dict-select-tag
                  style="width: 170px; margin-right: 15px"
                  placeholder="请选择年级"
                  v-model="queryParam.gradeId"
                  dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
                  :isShowEmpty="false"
                  @select="$set(queryParam, 'classId', undefined)"
                />
                <j-dict-select-tag
                  style="width: 170px; margin-right: 15px"
                  placeholder="请选择班级"
                  v-model="queryParam.classId"
                  :dictCode="
                    'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
                  "
                  :async="true"
                  :disabled="!queryParam.gradeId"
                  :isShowEmpty="false"
                />
                <a-range-picker
                  v-model="dateRange"
                  class="search-space"
                  style="width: 240px"
                  @change="changeDateRange"
                />
                <j-dict-select-tag
                  v-model="queryParam.care"
                  placeholder="关爱等级"
                  dictCode="care_list"
                  class="search-space"
                />
                <a-input-search
                  v-model="queryParam.studentName"
                  placeholder="请输入学生名字"
                  class="search-space"
                  style="width: 170px"
                  @change="searchName"
                />
                <a-button type="primary" @click="searchQuery">查询</a-button>
                <a-button
                  type="primary"
                  @click="searchReset"
                  icon="reload"
                  style="margin-left: 15px"
                >
                  重置
                </a-button>
              </div>
              <a-button
                type="primary"
                icon="download"
                :loading="exportXlsLoading"
                style="margin-left: auto"
                @click="handleExportXls(item.tab)"
              >
                导出
              </a-button>
            </div>
            <span slot="specialStu" slot-scope="{ record }" class="special-stu">
              {{ record.specialStu }}
            </span>
            <template slot="action" slot-scope="{ record }">
              <div class="action-detail">
                <span @click="assessClick(record)">评估</span>
                <a-divider type="vertical" />
                <span @click="viewArchives(record)">查看档案</span>
              </div>
            </template>
          </TableList>
        </a-tab-pane>
      </a-tabs>
      <!-- 评估模态框 -->
      <AssessModal ref="assessModalRef" @refresh="loadData" />
    </div>
  </div>
</template>
<script>
import TableList from '@/components/chart/TableList'
import { getAction } from '@api/manage'
import { getDictCodeData, simpleDebounce } from '@/utils/util'
import AssessModal from '@/comUi/AssessModal'
import moment from 'moment'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import Breadcrumb from '@/components/Breadcrumb/index'

export default {
  name: 'PsyScaleEvaluat',
  components: {
    Breadcrumb,
    TableList,
    AssessModal,
  },
  mixins: [JeecgListMixin],
  data() {
    return {
      breadcrumbList: [
        {
          label: '心理工作概览',
          isBack: true,
        },
        {
          label: '心理量表评估',
        },
      ],
      tabKey: 1,
      dateRange: [],
      // tab列表配置
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          align: 'center',
        },
        {
          title: '计划名称',
          dataIndex: 'planId_dictText',
          align: 'center',
        },
        {
          title: '班级',
          dataIndex: 'className',
          align: 'center',
        },
        {
          title: '姓名',
          dataIndex: 'studentName',
          align: 'center',
        },
        {
          title: '重点关爱名单',
          dataIndex: 'careList_dictText',
          align: 'center',
        },
        {
          title: '异常项',
          dataIndex: 'abnormalItems',
          align: 'center',
          customRender: (_, record) => {
            return record.abnormalItems.length > 30 ? (
              <a-tooltip>
                <template slot="title">{record.abnormalItems}</template>
                {record.abnormalItems.slice(0, 30) + '...'}
              </a-tooltip>
            ) : (
              record.abnormalItems
            )
          },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      tabPaneConfig: [
        {
          tab: '总评估',
          key: 1,
        },
        {
          tab: '未评估',
          key: 2,
        },
      ],
      url: {
        list: '/statisticV2/getTotalAssessmentList',
        exportXlsUrl: 'statisticV2/exportTotalAssessmentXls',
      },
      disableMixinCreated: true,
    }
  },
  created() {
    const currTabKey = this.$route.query?.index
    if (currTabKey) {
      this.tabKey = Number(currTabKey)
    }
    this.queryParam.type = this.tabKey
    this.loadData(1)
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    handleTabChange(key) {
      this.tabKey = key
      this.queryParam.type = key
      this.loadData(1)
    },
    changeDateRange(dateArr) {
      this.queryParam.beginDate = moment(dateArr[0]).format('YYYY-MM-DD')
      this.queryParam.endDate = moment(dateArr[1]).format('YYYY-MM-DD')
    },
    // 重置
    searchReset() {
      this.queryParam = {}
      this.dateRange = []
      this.queryParam.type = this.tabKey
      this.loadData(1)
    },
    searchName: simpleDebounce(function (event) {
      this.queryParam.studentName = event.target?.value?.trim()
      this.loadData(1)
    }, 800),
    assessClick(data) {
      this.$refs.assessModalRef.showModal(data)
    },
    viewArchives(record) {
      this.$router.push({
        path: '/school/mentalHealth/ArchivesViewPage',
        query: {
          studentId: record.studentId,
        },
      })
    },
  },
}
</script>
<style scoped lang="less">
.query-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.action-detail {
  min-width: 100px !important;
  color: #0077fa !important;
  cursor: pointer !important;
}

.search-space {
  width: 140px;
  margin-right: 15px;
}

.continuously {
  padding: 2px 8px;
  color: #f87654;
  background-color: #fff4f1;
  border-radius: 12px;
}

.careList-dictText {
  padding: 2px 8px;
  color: #35a7fa;
  background-color: #eff4ff;
  border-radius: 12px;
}

.special-stu {
  padding: 2px 8px;
  color: #6188fa;
  background-color: #eff4ff;
  border-radius: 12px;
}
</style>
